// extracted by mini-css-extract-plugin
export default {"arrow":"PrevNextArrows_arrow__7sdZF"};